import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { Navigate } from 'react-router-dom'
import { setAdminAuth } from '../../redux/authSlice'
import { RootState } from '../../redux/store'
import { useDispatch, useSelector } from 'react-redux'
import { t } from 'i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faLock, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import '../auth/login.css'

const LoginAdmin: React.FC = () => {
  const [email, setEmail]         = useState('')
  const [password, setPassword]   = useState('')
  const [showPass, setShowPass]   = useState(false)
  const [error, setError]         = useState<string | null>(null)
  const [loading, setLoading]     = useState(false)
  const adminAuth = useSelector((state: RootState) => state.auth.admin)
  const dispatch = useDispatch()

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)
    setLoading(true)
    try {
      const { data } = await axios.post('admin/login', { email, password }, { withCredentials: true })
      localStorage.setItem('adminToken', data.token)
      axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`
      dispatch(setAdminAuth(true))
      window.location.reload()
    } catch {
      setError('Authentication failed. Please check your email and password.')
      setLoading(false)
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem('adminToken')
      if (!token) {
        dispatch(setAdminAuth(false))
        return
      }
      try {
        const { data } = await axios.get('admin/admin')
        if (data) dispatch(setAdminAuth(true))
      } catch {
        dispatch(setAdminAuth(false))
      }
    }
    checkAuth()
  }, [dispatch])

  if (adminAuth) return <Navigate to='/' />

  return (
    <div className='lp-root'>
      <div className='lp-mesh' />
      <div className='lp-mesh-noise' />

      <div className='lp-page'>
        <div className='lp-right'>
          <div className='lp-form-card'>
            <div className='lp-card-stripe' />
            <div className='lp-card-body'>

              <div className='lp-brand' style={{ marginBottom: 22 }}>
                <div className='lp-brand-mark'>T</div>
                <div>
                  <div className='lp-brand-name'>TimeBerlo.com</div>
                  <div className='lp-brand-tag'>Admin Panel</div>
                </div>
              </div>

              <div className='lp-greeting'>Admin panel 🔐</div>
              <div className='lp-greeting-sub'>Sign in to manage the TimeBerlo portal.</div>

              {error && <div className='lp-err-banner'>{error}</div>}

              <form onSubmit={handleLogin}>
                {/* Email */}
                <div className='lp-field'>
                  <div className='lp-inp-wrap'>
                    <span className='lp-inp-icon'><FontAwesomeIcon icon={faEnvelope} /></span>
                    <input
                      className='lp-inp'
                      type='email'
                      placeholder={t('Email')}
                      autoComplete='email'
                      value={email}
                      onChange={e => setEmail(e.target.value)}
                    />
                  </div>
                </div>

                {/* Password */}
                <div className='lp-field'>
                  <div className='lp-inp-wrap'>
                    <span className='lp-inp-icon'><FontAwesomeIcon icon={faLock} /></span>
                    <input
                      className='lp-inp'
                      type={showPass ? 'text' : 'password'}
                      placeholder={t('Password')}
                      autoComplete='current-password'
                      style={{ paddingRight: '44px' }}
                      value={password}
                      onChange={e => setPassword(e.target.value)}
                    />
                    <button type='button' className='lp-inp-eye' aria-label={t('Password')} onClick={() => setShowPass(p => !p)}>
                      <FontAwesomeIcon icon={showPass ? faEyeSlash : faEye} />
                    </button>
                  </div>
                </div>

                <button type='submit' className='lp-btn-submit' disabled={loading}>
                  {loading
                    ? <><div className='lp-spinner' /><span>{t('LoginLog')}…</span></>
                    : <><span>{t('LoginLog')}</span><span className='lp-btn-arrow'>→</span></>
                  }
                </button>
              </form>

            </div>
          </div>

          <div className='lp-trust-row'>
            <div className='lp-trust-item'>🔒 <span>{t('TrustSsl')}</span></div>
            <div className='lp-trust-dot' />
            <div className='lp-trust-item'>version 0.01</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LoginAdmin
